module.exports = __webpack_public_path__ + "img/succes-pin.f00deba8.png";